// Limpa o HTML dos documentos (procuração, declarações) antes de ir para a tela via dangerouslySetInnerHTML.
// O texto personalizado de um modelo é HTML editado pela empresa, e os dados de cliente/veículo vêm do cadastro,
// do OCR ou da consulta de CNPJ: sem esta limpeza, um "<img onerror=...>" executaria código com o login de quem
// abrir o documento. Lista de permissões: só tags/atributos de formatação sobrevivem; o resto é descartado
// (script, iframe, eventos on*, links javascript:, etc.).

const TAGS_PERMITIDAS = new Set([
  'P', 'DIV', 'SPAN', 'BR', 'HR', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'SUB', 'SUP', 'SMALL',
  'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'PRE',
  'TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR', 'TD', 'TH', 'CAPTION', 'COLGROUP', 'COL'
]);

// Tags cujo conteúdo também é descartado (não é texto de documento)
const TAGS_DESCARTADAS_COM_CONTEUDO = new Set([
  'SCRIPT', 'STYLE', 'IFRAME', 'FRAME', 'FRAMESET', 'OBJECT', 'EMBED', 'NOSCRIPT', 'TEMPLATE',
  'SVG', 'MATH', 'LINK', 'META', 'BASE', 'FORM', 'INPUT', 'BUTTON', 'SELECT', 'TEXTAREA', 'TITLE', 'HEAD'
]);

const ATRIBUTOS_PERMITIDOS = new Set(['class', 'style', 'colspan', 'rowspan', 'align', 'width']);

// style só com declarações simples: nada de url(), expression() ou @import
const STYLE_PERIGOSO = /url\s*\(|expression\s*\(|@import|javascript:|behavior\s*:/i;

function limparNo(no, documento) {
  Array.from(no.childNodes).forEach((filho) => {
    if (filho.nodeType === 3) return; // texto
    if (filho.nodeType !== 1) { // comentários e afins
      filho.remove();
      return;
    }
    const tag = filho.tagName.toUpperCase();
    if (TAGS_DESCARTADAS_COM_CONTEUDO.has(tag)) {
      filho.remove();
      return;
    }
    limparNo(filho, documento);
    if (!TAGS_PERMITIDAS.has(tag)) {
      // Tag desconhecida (a, img, ...): some a tag, fica o texto de dentro
      const fragmento = documento.createDocumentFragment();
      while (filho.firstChild) fragmento.appendChild(filho.firstChild);
      filho.replaceWith(fragmento);
      return;
    }
    Array.from(filho.attributes).forEach((atributo) => {
      const nome = atributo.name.toLowerCase();
      if (!ATRIBUTOS_PERMITIDOS.has(nome) || (nome === 'style' && STYLE_PERIGOSO.test(atributo.value))) {
        filho.removeAttribute(atributo.name);
      }
    });
  });
}

export function sanitizarHtml(html) {
  if (!html) return '';
  const documento = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  limparNo(documento.body, documento);
  return documento.body.innerHTML;
}
